import { Component } from '@angular/core';
import { GlobalProvider } from '../../providers/global/global';
import { HttpParams, HttpClient } from '@angular/common/http';
import { AlertController, NavParams, NavController, ModalController } from 'ionic-angular';
import { AddRateManualPopupPage } from '../../pages/add-rate-manual-popup/add-rate-manual-popup';

/**
 * Generated class for the Timesheet3Component component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'timesheet3',
  templateUrl: 'timesheet3.html'
})
export class Timesheet3Component {

  customAvailabilityAlertOptions: any = {
    title: 'Days',
  };
  today;
  //dt1: any;
  minhours: number;
  maxhours: number;

  dt1table1: any;
  dt1table2: any;
  dt1table3: any;
  dt1table4: any;

  dt2table1: any;
  dt2table2: any;
  dt2table3: any;
  dt2table4: any;

  time;
  day;
  newMin: string;
  newMax: string;
  interval: number;
  minuteItervals: Array<number>;
  minuteItervalsString: string;
  hourInterval: Array<number>
  hourItervalsString: string;

  res2: any;
  grid2: string;
  save_res: string;
  save_data: any;
  //dt2: any;
  tab2id: string;
  res1: any;
  quantity6: string;
  quantity7: string;

  iRow: number;
  jDay: number;
  temp: string;
  tempDay: string;

  show_timesheetinstructions0: boolean = false;
  show_timesheetinstructions1: boolean = false;

  options: Array<any> = [];

  constructor(public http: HttpClient, public global: GlobalProvider, public navCtrl: NavController,
    public navParams: NavParams, private alertCtrl: AlertController , private modalCtrl: ModalController) {


    if (this.global.grid1Visibility) {

      this.dt1table1 = JSON.parse(this.global.dt_grid1[0]);
      this.dt1table2 = JSON.parse(this.global.dt_grid1[1]);
      this.dt1table3 = JSON.parse(this.global.dt_grid1[2]);
      this.dt1table4 = JSON.parse(this.global.dt_grid1[3]);

      //console.log('dt1table2: ' + this.dt1table2[0]);

      //nDays represent the number of days in the timesheet, it can be any number between 1 and 7
      //debugger;
      for (var i = 1; i <= 7; i++) {
        //this.qIndex = 'Quantity' + String(i);
        if (this.dt1table1[0]['Quantity' + String(i)] == '') {
          this.global.ndays = i - 1;
          break;
        }
        else {
          this.global.ndays = 7;
        }
      }
      //console.log('nDays: ' + this.global.ndays);


      this.global.CTRLInterval = this.dt1table3[0].CTRLInterval;
      this.global.CTRLMin = this.dt1table3[0].CTRLMin;
      this.global.CTRLMax = this.dt1table3[0].CTRLMax;

      //nRows represent the number of rows to be drawn in Grid1, whether there will be overtime,.. or not.
      this.global.nrowsGrid1 = this.dt1table3.length;
      //console.log('nRowsGrid1: ' + this.global.nrowsGrid1);
    }

    if (this.global.grid2Visibility) {

      this.dt2table1 = JSON.parse(this.global.dt_grid2[0]);
      this.dt2table2 = JSON.parse(this.global.dt_grid2[1]);
      this.dt2table3 = JSON.parse(this.global.dt_grid2[2]);
      this.dt2table4 = JSON.parse(this.global.dt_grid2[3]);

      for (var i = 1; i <= 7; i++) {
        //this.qIndex = 'Quantity' + String(i);
        if (this.dt2table1[0]['Quantity' + String(i)] == '') {
          this.global.ndays = i - 1;
          break;
        }
        else {
          this.global.ndays = 7;
        }
      }
      //nRows represent the number of rows to be drawn in Grid2, whether there will be overtime,.. or not.
      this.global.nrowsGrid2 = this.dt2table3.length;
      //console.log('nRowsGrid2: ' + this.global.nrowsGrid2);

      //get grid2 ddl options 
      //this.options
      var ddldaysarray = this.dt2table1[0]['DayDDLValues'].split(",");
      for (var i = 0; i < ddldaysarray.length; i++) {
        var val = "0.00";
        if (ddldaysarray[i].trim() == 'Zero Days' || ddldaysarray[i].trim() == 'Zero')
          val = "0.00";
        else if (ddldaysarray[i].trim() == 'Half Day')
          val = "0.50";
        else if (ddldaysarray[i].trim() == 'One Day' || ddldaysarray[i].trim() == 'One')
          val = "1.00";
        else
          val = ddldaysarray[i].split(" ")[0];

        this.options.push({ text: ddldaysarray[i].trim(), value: val });
      }
    }


    this.global.ndaysIndex = 1;

    //this.grid2 = this.global.dayArray[this.global.ndaysIndex - 1];

    this.timeInterval();

    if (this.global.contacttype == '0') {
      this.show_timesheetinstructions0 = true;
    }
    if (this.global.contacttype == '1') {
      this.show_timesheetinstructions1 = true;
    }

    if (this.global.FlipGrids == true) {
      //console.log('FlipGrids');
    }


  }

  timeInterval() {

    this.interval = Number(this.global.CTRLInterval)
    var updatedInterval = 0;
    this.minuteItervals = new Array;
    this.minuteItervals[0] = 0;
    var i = 1;
    while (updatedInterval + this.interval < 60) {
      //debugger;
      updatedInterval = updatedInterval + this.interval;
      this.minuteItervals[i] = updatedInterval;
      i = i + 1;
    }


    this.minuteItervalsString = this.minuteItervals.join(',');

    this.hourInterval = new Array;
    for (i = Number(this.global.CTRLMin); i <= Number(this.global.CTRLMax); i++) {

      this.hourInterval[i] = i;

    }
    this.hourItervalsString = this.hourInterval.join(',');

  }

  httpRequestGrid1_save(gridtype: number, value: string, action: string) {

    var p: any = {};
    p.timesheetid = this.global.timesheetid;
    p.contacttype = this.global.contacttype;
    p.action = action;
    p.value = value;


    //debugger;
    if (gridtype == 1) {
      p.datadate = this.dt1table1[0]['Quantity' + String(this.global.ndaysIndex)];
      p.contractid = this.dt1table3[this.iRow].ContractId;
      p.ratesid = this.dt1table3[this.iRow].RatesId;
    }
    else if (gridtype == 2) {
      p.datadate = this.dt2table1[0]['Quantity' + String(this.global.ndaysIndex)];
      p.contractid = this.dt2table3[this.iRow].ContractId;
      p.ratesid = this.dt2table3[this.iRow].RatesId;
    }


    const params = new HttpParams()
      .set('j', JSON.stringify(p))


    this.http.post('timesheets/timesheet_save/', params).subscribe(

      (data) => {


        this.save_data = data;

        this.save_res = JSON.parse(this.save_data.dt)[0].Result;
        //console.log(this.save_res);

        //console.log('w: ' + this.save_res.substring(0,2));
        if (this.save_res.substring(0, 2) == 'WA') {

          this.presentWAConfirm(gridtype, value, this.save_res);
        }
        else if (this.save_res.substring(0, 2) == 'NA') {

          this.presentNAalert(gridtype, this.save_res);
        }
      },
      error => {
        alert('error');
      }
    );


  }


  pickerOfgrid1Type(iRow: number, jDay: number) {

    this.iRow = iRow;
    this.jDay = jDay;
    this.time = this.dt1table3[this.iRow]['Quantity' + this.jDay];
    this.httpRequestGrid1_save(1, this.time, 'CHECK');

  }


  dropdownOfgrid2Type(iRow: number, jDay: number) {

    this.iRow = iRow;
    this.jDay = jDay;

    this.day = this.dt2table3[this.iRow]['Quantity' + this.jDay];
    this.httpRequestGrid1_save(2, this.day, 'CHECK');

  }


  presentWAConfirm(gridtype: number, value: string, resMsg: string) {
    let alert = this.alertCtrl.create({
      message: resMsg.replace('WA', ''),
      buttons: [
        {
          text: 'Yes',
          handler: () => {
            //console.log('Yes clicked');

            this.httpRequestGrid1_save(gridtype, value, 'SAVE');



          }
        },
        {
          text: 'No',
          role: 'cancel',
          handler: () => {

            if (gridtype == 1) {
              this.dt1table3[this.iRow]['Quantity' + this.jDay] = this.temp;
            } else if (gridtype == 2) {
              this.dt2table3[this.iRow]['Quantity' + this.jDay] = this.tempDay;
            }
            //console.log('No clicked');
          }
        }
      ]
    });
    alert.present();
  }

  presentNAalert(gridtype: number, resMsg: string) {
    let alert = this.alertCtrl.create({
      subTitle: resMsg.replace('NA', ''),
      buttons: [
        {
          text: 'Ok',
          role: 'cancel',
          handler: () => {
            if (gridtype == 1) {
              this.dt1table3[this.iRow]['Quantity' + this.jDay] = this.temp;
            } else if (gridtype == 2) {
              this.dt2table3[this.iRow]['Quantity' + this.jDay] = this.tempDay;
            }
            //console.log('Ok clicked');
          }
        }
      ]
    });
    alert.present();
  }

  saveTemp(gridtype: number, iRow: number, jDay: number) {

    this.iRow = iRow;
    this.jDay = jDay;

    if (gridtype == 1) {
      this.temp = this.dt1table3[this.iRow]['Quantity' + this.jDay];
    } else if (gridtype == 2) {
      this.tempDay = this.dt2table3[this.iRow]['Quantity' + this.jDay];
    }
  }


  openAddRateManualPop() {
    
    // Pass parameters to the modal
    const modalParams = {
      timesheetid: this.global.timesheetid
    };

    const modal = this.modalCtrl.create(AddRateManualPopupPage, modalParams);
    modal.present();
    
    modal.onDidDismiss((data) => {
      if (data) {
        console.log('Popup returned data:', data);
        // You can handle the returned data here
        // For example, show an alert or update the UI


          let ratesData=[];
          if(data.ratesperid == 3) //Day //add to grid2
            ratesData = this.dt2table3;
          else if(data.ratesperid == 1) //hour //add to grid1
            ratesData = this.dt1table3;

          if(!ratesData) ratesData = [];

          let contractId = 0;
          if(this.dt2table3){
            if(this.dt2table3.length) {
              contractId = this.dt2table3[0]['ContractId']
            }
          }
          if(this.dt1table3){
            if(this.dt1table3.length){
              contractId = this.dt1table3[0]['ContractId']
            }
          }
          
          // Create new row object
          const newRow = {
            ContractId: contractId,
            RatesId: data.ratesid,
            Enabled: 1,
            Type: data.ratename,
            RatesPer: data.ratesperid ==3 ? 'Day' : 'Hour',
            Quantity1: data.ratesperid ==3 ? '0.00': "00:00",
            Quantity2: data.ratesperid ==3 ? '0.00': "00:00",
            Quantity3: data.ratesperid ==3 ? '0.00': "00:00",
            Quantity4: data.ratesperid ==3 ? '0.00': "00:00",
            Quantity5: data.ratesperid ==3 ? '0.00': "00:00",
            Quantity6: data.ratesperid ==3 ? '0.00': "00:00",
            Quantity7: data.ratesperid ==3 ? '0.00': "00:00",
            TotalTime: data.ratesperid ==3 ? '0.00': "00:00",
            CTRLInterval: 5,
            CTRLMin: 0,
            CTRLMax: 12,
            ProjectCodeType: 0,
            ProjectCodeReadOnly: 0,
            ExpenseType: 0,
            ExpenseReadOnly: 0,
            ResetButton: "0",
            DayDDLValues: "Zero Days,Half Day,One Day",
            Ordering: "7" // Increment the ordering
          };

          console.log(newRow)

          // Add the new row to the array
          ratesData.push(newRow);

          console.log(ratesData)

          // Convert back to JSON string and update dt_grid
          if(data.ratesperid == 3)
          {
            this.dt2table3 = ratesData;
            this.global.nrowsGrid2 = this.dt2table3.length;
            
            
            //in case there were no rates of this type before
            if(!this.global.grid2Visibility) {
              this.dt2table1 = this.dt1table1;
              this.dt2table2 = this.dt1table2;

              var ddldaysarray = this.dt2table1[0]['DayDDLValues'].split(",");
              for (var i = 0; i < ddldaysarray.length; i++) {
                var val = "0.00";
                if (ddldaysarray[i].trim() == 'Zero Days' || ddldaysarray[i].trim() == 'Zero')
                  val = "0.00";
                else if (ddldaysarray[i].trim() == 'Half Day')
                  val = "0.50";
                else if (ddldaysarray[i].trim() == 'One Day' || ddldaysarray[i].trim() == 'One')
                  val = "1.00";
                else
                  val = ddldaysarray[i].split(" ")[0];

                this.options.push({ text: ddldaysarray[i].trim(), value: val });
              }
              
              this.global.grid2Visibility=true;
            }
          }
          else if(data.ratesperid == 1){
            this.dt1table3 = ratesData;
            this.global.nrowsGrid1 = this.dt1table3.length;

            //in case there were no rates of this type before
            if(!this.global.grid1Visibility) {
              this.dt1table1 = this.dt2table1;
              this.dt1table2 = this.dt2table2;
              this.global.grid1Visibility=true;

            }
          }




      }
    });
  }


}



// WEBPACK FOOTER //
// ./src/components/timesheet3/timesheet3.ts